export default {
    title: 'Statistikerhebung erstellen',
    createStatisticSurvey: 'Statistikerhebung erstellen',
    createAndEditStatisticSurvey: 'Erstellen und weiter bearbeiten',
    createStatisticSurveySuccess: 'Die Statistikerhebung wurde erfolgreich erstellt.',
    createStatisticSurveyError: 'Die Statistikerhebung konnte nicht erstellt werden.'
}